import { getInstance } from "../../core/axios-gateway";

const BASE_PATH = "/api/suppliers/fcm-tokens";

export type TFcmTokenType = "MOBILE" | "WEB";

export type TCreateFcmTokenRequest = {
  userId: string;
  token: string;
  type: TFcmTokenType;
};

export type TFcmTokenResponse = {
  id: string;
  userId: string;
  token: string;
  type: TFcmTokenType;
};

export const registerFcmToken = async (data: TCreateFcmTokenRequest) => {
  return getInstance()
    .post(BASE_PATH, data)
    .then((res) => res.data);
};

export const getFcmTokensByUser = async (userId: string): Promise<TFcmTokenResponse[]> => {
  return getInstance()
    .get(`${BASE_PATH}/user/${userId}`)
    .then((res) => res.data);
};

export const updateFcmToken = async (tokenId: string, token: string): Promise<TFcmTokenResponse> => {
  return getInstance()
    .put(`${BASE_PATH}/${tokenId}`, { token })
    .then((res) => res.data);
};

export const upsertFcmToken = async (userId: string, token: string, type: TFcmTokenType = "WEB") => {
  const existing = await getFcmTokensByUser(userId);
  const match = existing.find((t) => t.type === type);
  if (match) {
    return updateFcmToken(match.id, token);
  }
  return registerFcmToken({ userId, token, type });
};

export type TSendPushNotificationRequest = {
  title: string;
  description: string;
  data?: Record<string, string>;
};

export const sendPushNotification = async (commercialId: string, request: TSendPushNotificationRequest) => {
  return getInstance()
    .post(`/api/suppliers/push-notifications/commercial/${commercialId}`, request)
    .then((res) => res.data);
};
